/**
 * @generated SignedSource<<78dfe34c1237cefb73579f70f812e351>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ValidatePrefixInput = {
  prefix?: string | null;
  domain?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type validatePrefixMutation$variables = {
  input: ValidatePrefixInput;
};
export type validatePrefixMutation$data = {
  readonly validatePrefix: {
    readonly valid: string | null;
  } | null;
};
export type validatePrefixMutation = {
  variables: validatePrefixMutation$variables;
  response: validatePrefixMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidatePrefixPayload",
    "kind": "LinkedField",
    "name": "validatePrefix",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "validatePrefixMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "validatePrefixMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "147897341a1c6c676b212b0013b96299",
    "id": null,
    "metadata": {},
    "name": "validatePrefixMutation",
    "operationKind": "mutation",
    "text": "mutation validatePrefixMutation(\n  $input: ValidatePrefixInput!\n) {\n  validatePrefix(input: $input) {\n    valid\n  }\n}\n"
  }
};
})();

(node as any).hash = "2fc09ea16b4bf69a688b71247c909217";

export default node;
